import { Channel } from './channel';
import { Club } from './club';
import { USER_PERMISSIONS } from './user';

export const ROLE_ADMIN = 'ADMIN';
export const ROLE_PROMOTER = 'PROMOTER';
export const ROLE_TEAM_LEADER = 'TEAM_LEADER';
export const ROLE_DOOR_MANAGER = 'DOOR_MANAGER';
export const ROLE_DOOR_DIRECTOR = 'DOOR_DIRECTOR';
export const ROLE_OPERATIONS_DIRECTOR = 'OPERATIONS_DIRECTOR';
export const ROLE_OPERATIONS_MANAGER = 'OPERATIONS_MANAGER';
export const ROLE_MARKETING_DIRECTOR = 'MARKETING_DIRECTOR';
export const ROLE_MARKETING_MANAGER = 'MARKETING_MANAGER';
export const ROLE_FINANCE_MANAGER = 'FINANCE_MANAGER';
export const ROLE_CUSTOMER_SERVICE = 'CUSTOMER_SERVICE';

export interface CompanyRole {
  id: string;
  name: CompanyRoles;
}

export interface CompanyPermission {
  id: string;
  name: keyof typeof USER_PERMISSIONS;
}

export type CompanyRoles =
  | typeof ROLE_ADMIN
  | typeof ROLE_PROMOTER
  | typeof ROLE_TEAM_LEADER
  | typeof ROLE_DOOR_DIRECTOR
  | typeof ROLE_DOOR_MANAGER
  | typeof ROLE_OPERATIONS_DIRECTOR
  | typeof ROLE_OPERATIONS_MANAGER
  | typeof ROLE_MARKETING_DIRECTOR
  | typeof ROLE_MARKETING_MANAGER
  | typeof ROLE_FINANCE_MANAGER
  | typeof ROLE_CUSTOMER_SERVICE;

export const ROLES_ORDER = [
  ROLE_ADMIN,
  ROLE_FINANCE_MANAGER,
  ROLE_OPERATIONS_DIRECTOR,
  ROLE_OPERATIONS_MANAGER,
  ROLE_MARKETING_DIRECTOR,
  ROLE_MARKETING_MANAGER,
  ROLE_CUSTOMER_SERVICE,
  ROLE_DOOR_DIRECTOR,
  ROLE_DOOR_MANAGER,
  ROLE_TEAM_LEADER,
  ROLE_PROMOTER,
];

export const ADMIN_COMPANY_PROFILER_ROLES = [
  ROLE_ADMIN,
  ROLE_OPERATIONS_DIRECTOR,
  ROLE_OPERATIONS_MANAGER,
  ROLE_MARKETING_DIRECTOR,
  ROLE_MARKETING_MANAGER,
];

export const HIDDEN_ROLES = [ROLE_PROMOTER, ROLE_TEAM_LEADER];

export interface Company {
  id: string;
  legacyId: string;
  name: string;
  commercialName: string;
  defaultChannel: Omit<Channel, 'checked' | 'value'>;
  lookerStudioUrl?: string;
  logoUrl?: string;
  role?: CompanyRoles;
  clubs?: Club[];
  channel?: {
    id: string;
    name: string;
    slug: string;
    legacyId: string;
  };
  team?: {
    id: string;
    name: string;
    legacyId: string;
  };
  doorManager?: {
    name: string;
    legacyId: string;
  };
}

export interface CompanyUser extends Omit<Company, 'team'> {
  teams?: [
    {
      id: string;
      name: string;
      legacyId: string;
    },
  ];
}
